module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0043.jpg?v=31906f21";